import { Controller } from "@/controllers/Controller";

/**
 * Controller for French Directory Cache API
 */
export class FrenchDirectoryCacheController extends Controller {

    static create(body) {
        return this.requestBuilder("POST", `/ms-transmission/french-directory-cache/client`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("DELETE", `/ms-transmission/french-directory-cache/client/${id}`, true);
    }

    static clientDirectoryTable(params = "") {
        return this.requestBuilder("GET", `/ms-transmission/french-directory-cache/table/client-directory${params}`, true);
    }

}
